module.exports = __webpack_public_path__ + "media/images/team_member/member_2-03f7f12486e8b8553edec1ff17bad2e5.jpg";